import { Link, useNavigate } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ContainerSVG } from "components/waste-icons/svgs/ContainerSVG";
import OrderByHeaders from "components/ordering/OrderByHeaders";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

const TableIslands = ({ itemsShown, onClickRow, orderingRef }) => {
    const { t: _Tt } = useTranslation("tables");
    const navigate = useNavigate();
    const onClickTd = (e) => {
        let id = e.currentTarget.dataset.id;
        navigate(`/data-view/island/${id}/`);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    return (
        <table className="table table-striped table-sticky-horizontal">
            <thead>
                <tr>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                    <th style={{ ...stickyHeaderStyle }} className="sticky-top border-bottom-sticky">
                        {_Tt("routes.actives")}
                    </th>
                </tr>
            </thead>
            <tbody>
                {itemsShown.map((item, index) => (
                    <tr key={index} data-idx={index}>
                        <td title="Ver datos isla" className="cursor-pointer" data-id={item.id} onClick={onClickTd}>
                            {item.name}
                            <br />
                            <small>{item.full_address}</small>
                            <br />
                            <small className="text-muted">{item.description}</small>
                        </td>
                        <td>
                            <div className="row card-asset-basic">
                                {item.actives.map((act, idx) => (
                                    <div className="col asset-icon" key={idx}>
                                        <div className="row">
                                            <div className="col asset-svg p-0 text-center">
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id={`tooltip-${act.uid}`}>
                                                            {act.uuids.map((uuid, uidx) => (
                                                                <div key={uidx}>
                                                                    UUID: <strong>{uuid}</strong>
                                                                </div>
                                                            ))}
                                                        </Tooltip>
                                                    }>
                                                    <>
                                                        <Link
                                                            to={`/asset-management/containers/?uid=${act.uid}`}
                                                            className="text-no-decoration"
                                                            title="Ver contenedor">
                                                            <ContainerSVG type={act.waste_type} width={35} height={47.546} />
                                                        </Link>
                                                        <div className="row">
                                                            <Link
                                                                to={`/data-view/data-container/${act.uid}/`}
                                                                className="text-no-decoration"
                                                                title="Ver datos">
                                                                <div className="col-12 text-muted fs-08 text-center p-0">
                                                                    {act.filling}%
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </>
                                                </OverlayTrigger>
                                            </div>
                                            <div className="col icons">
                                                {act.has_device ? (
                                                    act.uuids.map((uuid, uidx) => (
                                                        <Link to={`/asset-management/devices/?uuid=${uuid}`} key={uidx}>
                                                            <FontAwesomeIcon
                                                                icon="wifi"
                                                                title="Ver dispositivo"
                                                                className="text-success"
                                                            />
                                                        </Link>
                                                    ))
                                                ) : (
                                                    <></>
                                                )}
                                                {act.has_route ? (
                                                    <FontAwesomeIcon icon="truck-fast" title="Tiene Ruta" className="text-blue" />
                                                ) : (
                                                    <></>
                                                )}
                                                {act.has_alerts ? (
                                                    <Link to={`/alerts/alerts/?uid=${act.uid}`}>
                                                        <FontAwesomeIcon
                                                            icon="triangle-exclamation"
                                                            className="text-warning"
                                                            title="Tiene Alertas"
                                                        />
                                                    </Link>
                                                ) : (
                                                    <></>
                                                )}

                                                {act.active ? (
                                                    <></>
                                                ) : (
                                                    <FontAwesomeIcon icon="eye-slash" title="Desactivado" className="text-danger" />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableIslands;
